import { Component, OnInit, isDevMode, inject, Renderer2 } from '@angular/core';
import { Logger } from '@smarsh-cyber/shared/services';
import { iconSubset } from '@smarsh-cyber/shared';
import { IconSetService } from '@coreui/icons-angular';
import { AppMainFacadeService } from './services/app-main.facade';

@Component({
  selector: 'smarsh-cyber-app-main',
  templateUrl: 'app-main.component.html'
})
export class SmarshCyberAppMainComponent implements OnInit {
  appMainFacade = inject(AppMainFacadeService);
  readonly isError = this.appMainFacade.isError();

  constructor(
    iconSetService: IconSetService,
    private renderer: Renderer2
  ) {
    iconSetService.icons = { ...iconSubset };
  }

  ngOnInit(): void {
    // Setup logger
    if (!isDevMode()) {
      Logger.enableProductionMode();
    }

    this.loadCoveoIPXScript().then(() => {
      const widget = document.querySelectorAll('coveo-in-app-widget-loader')[0];
      const helpButton = widget.shadowRoot.querySelector('button');
      this.renderer.setStyle(widget, 'z-index', '1050');
      this.renderer.setStyle(helpButton, 'top', '18px');
      this.renderer.setStyle(helpButton, 'right', '100px');
      this.renderer.setStyle(helpButton, 'width', '88px');
      this.renderer.setStyle(helpButton, 'height', '28px');

      this.appMainFacade.isLoaded.subscribe((loaded) => {
        this.renderer.setStyle(
          helpButton,
          'visibility',
          loaded ? 'visible' : 'hidden'
        );
      });
    });
  }

  loadCoveoIPXScript() {
    //Load Coveo In-Product Experience
    return new Promise((resolve, reject) => {
      const scriptSrc =
        'https://platform.cloud.coveo.com/rest/organizations/smarshproductiony7nv4i2e/pages/8bbc4cff-de1d-4094-9be6-c0d0007d2d29/inappwidget/loader';

      // Check if script already exists
      const existingScript = document.querySelector(
        `script[src="${scriptSrc}"]`
      );
      if (existingScript) {
        resolve(true); // Already loaded
        return;
      }

      // Create and append script
      const script = this.renderer.createElement('script');
      script.src = scriptSrc;
      script.onload = resolve;
      script.onerror = reject;
      this.renderer.appendChild(document.body, script);
    });
  }
}
